import * as THREE from 'three';
import Stats from 'three/examples/jsm/libs/stats.module';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { GUI } from 'dat.gui'
import gsap from 'gsap';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
// RenderPass该通道在指定的场景和相机的基础上渲染出一个新场景
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';

let scene;
let camera;
let renderer;
let stats;
let gui;
let clock = new THREE.Clock()
let lastStage = -1; // 记录上一次的阶段
let composer;

let gradientTexture, particlesGeometry, particlesMaterial

let directionalLight

let material

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};
const params = {
  materialColor: '#ffeded',
  objectsDistance: 20, // y轴位置间隔
  count: 200, // 生成粒子数量
}
const cursor = {
  x: 0,
  y: 0
}

const laterParams = {
  strength: 0.8,
  radius: 0.4,
  threshold: 0.1
}

let cameraGroup = new THREE.Group()

let scrollY = window.scrollY
let previousTime = 0; // 上一秒时间
let models = []
let particles
const uniforms = {
  time: { value: 0 },
  progress: { value: 0 },
  uSize: { value: 1.0 }
}
const gltfLoader = new GLTFLoader()
let hcUrl = '/models/glb/货车.glb'
let msUrl = '/models/glb/煤山.glb'
let flUrl = '/models/glb/风力发电.glb'
let agvUrl = '/models/glb/agv小车.glb'
let hcModel, agvCarModel, msModel, flModel

export const init = (el) => {
  setScene();
  setCamera();
  setRenderer(el);
  // setStats();
  // setGui()
  addLight()
  addMesh()
  testModel()
  initPostProcessing()
  // createPlane()
  render();
  window.addEventListener('resize', () => {
    setResize();
  });

  return { gui }
};

const setScene = () => {
  scene = new THREE.Scene();
  scene.add(cameraGroup)
};

const setCamera = () => {
  camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 1000);
  camera.position.set(0, 0, 26);
  cameraGroup.rotation.x = THREE.MathUtils.degToRad(-18)
  cameraGroup.add(camera)
};

const setRenderer = (el) => {
  renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true
  });
  renderer.setSize(sizes.width, sizes.height);
  el.appendChild(renderer.domElement);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

};


const setStats = () => {
  stats = new Stats();
  document.body.appendChild(stats.dom);
};

// 设置自适应大小
const setResize = () => {
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  renderer.setSize(sizes.width, sizes.height);
  composer.setSize(window.innerWidth, window.innerHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
};


const setGui = () => {
  gui = new GUI()
  gui.addColor(params, 'materialColor').onChange(() => {
    material.color.set(params.materialColor)
    particlesMaterial.color.set(params.materialColor)
  })
}

// 获取模数和余数
const getMod = (num1, num2) => {
  return [Math.floor(num1 / num2), num1 % num2];
};



const mixFloatArray = (fromList, toList) => {
  if (fromList.length === toList.length) {
    return toList
  } else if (fromList.length < toList.length) {
    return toList.slice(0, fromList.length)
  } else if (fromList.length > toList.length) {
    const newArr = [];
    const len = fromList.length - toList.length;
    const [n1, n2] = getMod(len, toList.length);
    console.log(len, n1, n2)
    for (let i = 0; i < n1; i++) {
      newArr.push(...toList);
    }
    newArr.push(...toList, ...toList.slice(0, n2));
    const float32Arr = new Float32Array(newArr);
    return float32Arr
  }
};


// 添加light
const addLight = () => {
  directionalLight = new THREE.DirectionalLight('#ffffff', 1);
  directionalLight.position.set(1, 1, 0);
  scene.add(
    directionalLight
  )
}

const loadModel = (url) => {
  return new Promise((resolve, reject) => {
    gltfLoader.load(url, (gltf) => {
      const model = gltf.scene
      model.position.set(0, -2, 0)
      resolve(model)
    }, (xhr) => {
      // console.log((xhr.loaded / xhr.total * 100) + '% loaded')
    }, (error) => {
      reject(error)
    })
  })
}

export const getParticles = (models) => {
  const particles = new THREE.BufferGeometry();
  const positions = [];

  models.traverse((child) => {
    if (child instanceof THREE.Mesh) {
      const geometry = child.geometry.clone();
      geometry.applyMatrix4(child.matrixWorld);
      const positionAttribute = geometry.getAttribute('position');
      for (let i = 0; i < positionAttribute.count; i++) {
        const vertex = new THREE.Vector3();
        vertex.fromBufferAttribute(positionAttribute, i);
        positions.push(vertex.x, vertex.y, vertex.z);
      }
    }
  });

  particles.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

  const particleMaterial = new THREE.PointsMaterial({ color: 0x00ff00, size: 0.1 });
  const particleSystem = new THREE.Points(particles, particleMaterial);
  return particleSystem;
}

const createParticles = () => {
  // 创建粒子几何体
  const geometry = new THREE.BufferGeometry();
  const positions = models[0].geometry.attributes.position.array
  console.log(`geometry`, models[0])
  // 添加密度计算属性
  const densities = new Float32Array(positions.length / 3);
  for (let i = 0; i < densities.length; i++) {
    densities[i] = Math.random(); // 替换为实际密度计算
  }
  // 初始化attributes
  geometry.setAttribute('position', new THREE.BufferAttribute(models[0].geometry.attributes.position.array, 3));
  geometry.setAttribute('density', new THREE.BufferAttribute(densities, 1));
  geometry.setAttribute('prevPosition', new THREE.BufferAttribute(models[0].geometry.attributes.position.array, 3));
  geometry.setAttribute('nextPosition', new THREE.BufferAttribute(models[1].geometry.attributes.position.array, 3));

  // 创建着色器材质
  const material = new THREE.ShaderMaterial({
    vertexShader: `
					attribute vec3 prevPosition;
					attribute vec3 nextPosition;
          attribute float density;
          varying float vDensity;
					uniform float progress;
					uniform float uSize;
					
					void main() {
            vec3 pos = mix(prevPosition, nextPosition, smoothstep(0.0, 1.0, progress));
            vDensity = density;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
            gl_PointSize = uSize * (1.0 + density * 2.0); // 密度高的点更大
					}
			`,
    fragmentShader: `
      varying float vDensity;
      void main() {
        // 点状衰减
        vec2 uv = gl_PointCoord.xy - 0.5;
        float distance = length(uv);
        float strength = 1.0 - smoothstep(0.3, 0.5, distance);
        // 密度影响颜色
        vec3 baseColor = vec3(1.0, 0.4, 0.0);
        vec3 glowColor = vec3(1.0, 0.8, 0.5);

        vec3 finalColor = mix(baseColor, glowColor, vDensity);
        // float alpha = strength * (0.5 + vDensity * 0.5);
        
        // gl_FragColor = vec4(finalColor, alpha)
        // gl_FragColor = vec4(1.0, 0.4, 0.098, 1.0);
        gl_FragColor = vec4(0.525, 0.78, 1.0, 1.0);
      }
			`,
    uniforms,
    // blending: THREE.AdditiveBlending, // 启用叠加混合
    depthTest: false
  });

  // 创建粒子系统
  particles = new THREE.Points(geometry, material);
  scene.add(particles);
}
// let particleCount = 27000
// const geometry = new THREE.BufferGeometry();
// const positions = new Float32Array(particleCount * 3);
// const createPlane = () => {
//   // 初始化粒子位置和颜色
//   for (let i = 0; i < particleCount; i++) {
//     positions[i * 3] = (Math.random() - 0.5) * 10 + 5; // x
//     positions[i * 3 + 1] = (Math.random() - 0.5) * 10; // y
//     positions[i * 3 + 2] = (Math.random() - 0.5) * 10; // z
//   }

//   geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

//   // 着色器材质
//   const shaderMaterial = new THREE.ShaderMaterial({
//     vertexShader: `
// 				uniform float time;
// 				void main() {
// 						// 创建波动效果
// 						vec3 newPosition = position + vec3(
// 								sin(time + position.z * 2.0) * 0.3,
// 								cos(time + position.x * 2.0) * 0.3,
// 								sin(time * 0.5) * 0.2
// 						);

// 						vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
// 						gl_PointSize = 2.0;
// 						// gl_PointSize = 5.0 * (1.0 / -mvPosition.z); // 根据距离调整大小
// 						gl_Position = projectionMatrix * mvPosition;
// 				}
// 			`,

//     fragmentShader: `
// 					void main() {
// 							// 绘制圆形点
// 							vec2 coord = gl_PointCoord - vec2(0.5);
// 							if(length(coord) > 0.5) discard;
// 							gl_FragColor = vec4(1.0, 0.4, 0.0, 1.0);
// 					}
// 			`,

//     uniforms: uniforms,
//     vertexColors: true // 启用顶点颜色
//   });

//   // 创建粒子系统
//   const particles = new THREE.Points(geometry, shaderMaterial);
//   scene.add(particles);
// }

const testModel = async () => {
  hcModel = await loadModel(hcUrl, 0.3);
  msModel = await loadModel(msUrl, 100);
  agvCarModel = await loadModel(agvUrl);
  flModel = await loadModel(flUrl);

  hcModel.position.x = 5
  hcModel.rotateY(-Math.PI / 5)
  hcModel.updateMatrixWorld()

  msModel.position.x = 5
  msModel.rotation.y = (-Math.PI / 2)
  msModel.updateMatrixWorld()

  agvCarModel.position.x = 5
  // agvCarModel.rotateY(-Math.PI / 2)
  agvCarModel.rotation.y = (-Math.PI / 4)
  agvCarModel.updateMatrixWorld()

  flModel.position.x = 5
  flModel.position.y = -8
  flModel.scale.set(0.75, 0.75, 0.75)
  flModel.rotateY(-Math.PI / 11)
  flModel.updateMatrixWorld()

  const hcP = getParticles(hcModel)
  const msP = getParticles(msModel)
  const flP = getParticles(flModel)
  const agvP = getParticles(agvCarModel)
  // scene.add(hcModel, msModel, agvCarModel)
  models.push(hcP, msP, flP, agvP)
  createParticles()

}

const initPostProcessing = () => {
  composer = new EffectComposer(renderer);
  // 基础渲染通道：将场景和相机渲染到后期处理管线中
  const renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);
  // 添加辉光效果（Bloom）
  const bloomPass = new UnrealBloomPass(
    new THREE.Vector2(sizes.width, sizes.height), // 分辨率
    laterParams.strength,
    laterParams.radius,
    laterParams.threshold
  );
  composer.addPass(bloomPass);

  // gui.add(laterParams, 'strength', 0, 3).onChange(val => {
  //   bloomPass.strength = val
  //   console.log(`laterParams.strength`, laterParams.strength)
  // })
  // gui.add(laterParams, 'strength', 0, 3).onChange(val => {
  //   bloomPass.strength = val
  //   console.log(`laterParams.strength`, laterParams.strength)
  // })
  // gui.add(laterParams, 'radius', 0, 1).onChange(val => {
  //   bloomPass.radius = val
  // })
  // gui.add(laterParams, 'threshold', 0, 1).onChange(val => {
  //   bloomPass.threshold = val
  // })
};

const addMesh = () => {
  material = new THREE.MeshToonMaterial({
    color: params.materialColor,
    // map: gradientTexture
  })
  const positions = new Float32Array(params.count * 3)

  for (let i = 0; i < params.count; i++) {
    positions[i * 3] = (Math.random() - 0.5) * 40
    positions[i * 3 + 1] = params.objectsDistance * 0.5 - Math.random() * params.objectsDistance
    positions[i * 3 + 2] = (Math.random() - 0.5) * 40
  }
  particlesGeometry = new THREE.BufferGeometry()
  particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

  particlesMaterial = new THREE.PointsMaterial({
    color: params.materialColor,
    sizeAttenuation: true,
    size: 0.1,
    // map: particlesTexture
    // map: gradientTexture
  })

  const particles = new THREE.Points(particlesGeometry, particlesMaterial)

  scene.add(
    particles
  )
}

window.addEventListener('scroll', () => {
  scrollY = window.scrollY;
  // console.log(`scrollY`, scrollY);
  const newSection = Math.round(scrollY / sizes.height);
  // console.log(`newSection`, newSection);

  const maxStage = models.length - 1;

  const scrollPercent = Math.min(scrollY / window.innerHeight, maxStage);
  const newStage = Math.floor(scrollPercent);
  const progress = scrollPercent - newStage;
  // console.log(`scrollPercent`, scrollPercent, `progress`, progress, `newStage`, newStage)
  // gsap.to(uniforms.progress, {
  //   value: progress,
  //   duration: 0.3,
  //   ease: "power2.out",
  // });
  uniforms.progress.value = progress;
  if (newStage !== lastStage) {
    lastStage = newStage; // 更新 lastStage
    if (newStage === 0) {
      const nowFloatArray = particles.geometry.attributes.position.array
      const toArray = models[1].geometry.attributes.position.array
      const tos = mixFloatArray(nowFloatArray, toArray)
      particles.geometry.setAttribute('prevPosition', new THREE.BufferAttribute(models[0].geometry.attributes.position.array, 3));
      particles.geometry.setAttribute('nextPosition', new THREE.BufferAttribute(tos, 3));
    } else if (newStage === 1) {
      const nowFloatArray = particles.geometry.attributes.position.array
      const toArray = models[2].geometry.attributes.position.array
      const tos = mixFloatArray(nowFloatArray, toArray)
      particles.geometry.setAttribute('prevPosition', new THREE.BufferAttribute(models[1].geometry.attributes.position.array, 3));
      particles.geometry.setAttribute('nextPosition', new THREE.BufferAttribute(tos, 3));
    } else if (newStage === 2) {
      const nowFloatArray = particles.geometry.attributes.position.array
      const toArray = models[3].geometry.attributes.position.array
      const tos = mixFloatArray(nowFloatArray, toArray)
      particles.geometry.setAttribute('prevPosition', new THREE.BufferAttribute(models[2].geometry.attributes.position.array, 3));
      particles.geometry.setAttribute('nextPosition', new THREE.BufferAttribute(tos, 3));
    } else if (newStage === 3) {
      particles.geometry.setAttribute('prevPosition', new THREE.BufferAttribute(models[3].geometry.attributes.position.array, 3));
    }
  }
});

window.addEventListener('mousemove', (e) => {
  cursor.x = e.clientX / sizes.width - 0.5
  cursor.y = e.clientY / sizes.height - 0.5
});

const render = () => {
  // stats && stats.begin();
  const elapsedTime = clock.getElapsedTime()
  const deltaTime = elapsedTime - previousTime
  previousTime = elapsedTime

  const parallaxX = cursor.x * 1
  const parallaxY = -cursor.y * 1
  cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 20 * deltaTime;
  cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 20 * deltaTime;

  if (particles) {
    particles.position.x = Math.sin(elapsedTime * 3) * 0.1
    particles.position.y = Math.sin(elapsedTime * 3) * 0.1
  }

  for (let i = 0; i < params.count; i++) {
    const i3 = i * 3
    const x = particlesGeometry.attributes.position.array[i3]
    const y = particlesGeometry.attributes.position.array[i3 + 1]
    const z = particlesGeometry.attributes.position.array[i3 + 2]

    particlesGeometry.attributes.position.array[i3 + 2] = Math.cos(elapsedTime + y) * 1.5
  }

  particlesGeometry.attributes.position.needsUpdate = true

  if (composer) {
    composer.render();
  } else {
    renderer.render(scene, camera);
  }
  requestAnimationFrame(render);
  // stats && stats.end();
};
